<!-- `.ps-banner` (P/proto-states.js:50): glyph, `.t` sentence, `.ps-acts`. -->
<div class="agu-state-banner" [class.agu-state-banner--amber]="Tone === 'amber'" [class.agu-state-banner--error]="Tone === 'error'" [attr.role]="Tone === 'error' ? 'alert' : null">
    <agu-icon class="agu-state-banner__glyph" [Name]="Glyph" [Size]="18" />
    <span class="agu-state-banner__text">
        {{ Text }}<ng-content />
        @if (Note) {
            <span class="agu-state-banner__note" role="status">{{ Note }}</span>
        }
    </span>
    @if (ActionLabel) {
        <button type="button" class="agu-state-banner__btn" [class.agu-state-banner__btn--q]="Tone === 'error'" (click)="OnAction()">{{ ActionLabel }}</button>
    }
</div>
